'use client';

import { Facebook } from '@ahamove/icons';
import { loadJS } from '@ahm/common-helpers';
import { Button, Space, rem } from '@mantine/core';
import { useAuth } from '../auth-provider';
import type { FBAuthResponse } from '../hooks/use-fb-sdk';
import { isProd } from '../lib/constants';
import { authLocales, createTranslations, type Locales } from '../locales';
import { useAuthStore } from '../store/auth-store-provider';

type Props = {
  lang?: keyof Locales;
};
export default function FacebookLoginBtn({ lang = 'vi' }: Props) {
  const tAuth = createTranslations({ locales: authLocales, lang });
  const { loginViaSocial } = useAuth();

  const { facebookAppId, facebookAppVersion } = useAuthStore((state) => state);

  const locale = lang === 'vi' ? 'vi_VN' : 'en_US';
  const initializeFb = function () {
    const src = isProd
      ? `https://connect.facebook.net/${locale}/sdk.js`
      : `https://connect.facebook.net/${locale}/sdk/debug.js`;
    const attr = {
      id: 'facebook-jssdk',
    };

    return new Promise((resolve, reject) => {
      loadJS(src, attr)
        .then(() => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          FB.init({
            appId: facebookAppId,
            cookie: true,
            xfbml: true,
            version: facebookAppVersion ?? 'v20.0',
          });

          FB.AppEvents.logPageView(); // eslint-disable-line @typescript-eslint/no-unsafe-call
          // auto authenticate with the api if already logged in with facebook
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          FB.getLoginStatus((res: FBAuthResponse) => {
            if (res.status === 'connected' && res.authResponse) {
              resolve(res.authResponse);
            } else {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-call
              FB.login((res: FBAuthResponse) => {
                resolve(res.status === 'connected' ? res.authResponse : null);
              });
            }
          });
        })
        .catch(() => {
          console.log('cannot load FB');
          reject();
        });
    });
  };

  function handleClickFbLoginBtn() {
    try {
      void initializeFb().then((res: any) => {
        if (res) {
          loginViaSocial(res, 'facebook');
        }
      });
    } catch (error: any) {
      console.log('loginViaSocial error', error);
    }
  }

  if (!facebookAppId) {
    return null;
  }

  return (
    <Button
      type="button"
      px="md"
      h={rem(44)}
      fullWidth
      variant="light"
      color="neutral"
      c="neutral.6"
      // variant="filled"
      // color="rgb(23, 120, 242)"
      onClick={handleClickFbLoginBtn}
      leftSection={<Facebook width={24} height={24} />}
      rightSection={<Space w={24} />}
      justify="space-between"
      styles={{
        // root: {
        //   borderColor: 'rgb(23, 120, 242)',
        //   backgroundColor: 'rgb(23, 120, 242)',
        // },
        section: {
          flex: 'none',
        },
        label: {
          width: '100%',
          justifyContent: 'center',
        },
      }}
    >
      {tAuth('loginWithFacebook')}
    </Button>
  );
}
